var setSelect = {
	init: function() {
		this.setParameter();
		this.changeDefSelectStyle();
	},
	setParameter: function() {
		this.$target = $('#js-article-list');
		this.targetCategory = this.$target.find('.js-article-ul').data('category');
		this.$selectWrap = $('#js-change-wrap');
		this.$select = this.$selectWrap.find('#js-change');
	},
	// コンテンツによってselectタグのvalを切り替える
	changeDefSelectStyle: function() {
		switch(this.targetCategory) {
			case 'all':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-all').removeClass('is-job is-house is-live is-people is-country');
				break;
			case 'job':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-job').removeClass('is-all is-house is-live is-people is-country');
				break;
			case 'house':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-house').removeClass('is-all is-job is-live is-people is-country');
				break;
			case 'live':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-live').removeClass('is-all is-job is-house is-people is-country');
				break;
			case 'people':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-people').removeClass('is-all is-job is-house is-live is-country');
				break;
			case 'country':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-country').removeClass('is-all is-job is-house is-live is-people');
				break;
			case 'used':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-used').removeClass('is-all is-rent is-store is-land');
				break;
			case 'rent':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-rent').removeClass('is-all is-used is-store is-land');
				break;
			case 'store':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-store').removeClass('is-all is-used is-rent is-land');
				break;
			case 'land':
				this.$select.val(this.targetCategory);
				this.$selectWrap.addClass('is-land').removeClass('is-all is-used is-rent is-store');
				break;
		}
	}
};

module.exports = setSelect;


/*****************
 ** WEBPACK FOOTER
 ** ./app/source/pc/js/module/set_select.js
 ** module id = 2
 ** module chunks = 8
 **/